import React from "react";
import * as xmlService from "../../services/xml/xml-service";
import * as clientsearchservice from "../../services/client/client-search-service";
import DataTable from "../../components/data-table";
import { Link } from "react-router-dom";
import * as validation from "../../utils/validations";
import { Authorize } from "../../components/authorize";
import { validateEntitlement } from "../../common/validate-entitlement";
import { FUNCTIONALITY, ENTITLEMENTS } from "../../common/const";
import XmlDownload from "../../components/xml-download/xml-download";
import Utility from "../../components/modal";
import * as Loader from "../../common/common";

export default class SearchClient extends Authorize {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.clientCount = -1;
  }

  state = {
    client: {
      clientName: "",
      panNo: "",
      gstin: "",
      clientCode: "",
      mobileNo: "",
      email: "",
    },
    data: [],
    headers: [
      { title: "Name", accessor: "clientName", index: 0, dataType: "string" },
      { title: "Type", accessor: "userType", index: 1, dataType: "string" },
      { title: "PAN", accessor: "panNo", index: 2, dataType: "string" },
      { title: "GSTIN", accessor: "gstin", index: 3, dataType: "string" },
      {
        title: "Fin Ledger Code",
        accessor: "clientCode",
        index: 4,
        dataType: "string",
      },
      { title: "Status", accessor: "status", index: 5, dataType: "string" },
      {
        title: "Active/In-active",
        accessor: "activeInactive",
        index: 6,
        dataType: "string",
      },
      { title: "Mobile", accessor: "mobileNo", index: 7, dataType: "string" },
      { title: "Email", accessor: "email", index: 8, dataType: "string" },
      {
        title: "",
        accessor: "",
        index: 9,
        cell: (row) => {
          return (
            <div>
              {validateEntitlement(FUNCTIONALITY.kyc, ENTITLEMENTS.view) ? (
                <React.Fragment>
                  <Link
                    to={{
                      pathname: "/kycs/" + row.clientId + "/" + row.userType,
                      state: row.clientName,
                    }}
                  >
                    View
                  </Link>
                </React.Fragment>
              ) : null}
              {validateEntitlement(
                FUNCTIONALITY.kyc,
                ENTITLEMENTS.deactivate
              ) ? (
                <React.Fragment>
                  &nbsp; | &nbsp;
                  <a
                    onClick={this.updateClient.bind(
                      this,
                      row.clientId,
                      "deactivate"
                    )}
                    style={{ cursor: "pointer" }}
                    href="#"
                  >
                    De-activate
                  </a>
                </React.Fragment>
              ) : null}
              {validateEntitlement(FUNCTIONALITY.kyc, ENTITLEMENTS.delete) ? (
                <React.Fragment>
                  &nbsp; | &nbsp;
                  <a
                    onClick={this.updateClient.bind(
                      this,
                      row.clientId,
                      "delete"
                    )}
                    style={{ cursor: "pointer" }}
                    href="#"
                  >
                    Delete
                  </a>
                </React.Fragment>
              ) : null}
              {validateEntitlement(FUNCTIONALITY.kyc, ENTITLEMENTS.reopen) &&
              (row.status === "APPROVED" || row.status === "REJECTED") ? (
                <React.Fragment>
                  &nbsp; | &nbsp;
                  <a
                    onClick={this.updateClient.bind(
                      this,
                      row.clientId,
                      "reopen"
                    )}
                    style={{ cursor: "pointer" }}
                    href="#"
                  >
                    Re-Open
                  </a>
                </React.Fragment>
              ) : null}
              &nbsp; | &nbsp;
              <Link to={"/AuditLogs/" + row.clientId}>Audit Logs</Link>
              {validateEntitlement(
                FUNCTIONALITY.generateXMLCSV,
                ENTITLEMENTS.create
              ) && row.status === "APPROVED" ? (
                <div className="dropdown">
                  <button
                    type="button"
                    className="btn dropdown-toggle"
                    data-toggle="dropdown"
                  >
                    More
                  </button>
                  <div className="dropdown-menu">
                    {validateEntitlement(
                      FUNCTIONALITY.generateXMLCSV,
                      ENTITLEMENTS.create
                    ) && row.status === "APPROVED" ? (
                      <React.Fragment>
                        <span
                          className="dropdown-item"
                          onClick={this.regenerateXml.bind(
                            this,
                            row.clientId,
                            row.userType
                          )}
                        >
                          Regenerate INFOR XML
                        </span>
                        <XmlDownload
                          type="infor"
                          displayTitle="INFOR"
                          obj={{
                            clientId: row.clientId,
                            userType: row.userType,
                          }}
                        />
                      </React.Fragment>
                    ) : null}
                    {validateEntitlement(
                      FUNCTIONALITY.generateXMLCSV,
                      ENTITLEMENTS.create
                    ) &&
                    row.status === "APPROVED" &&
                    row.userType === "Customer" ? (
                      <React.Fragment>
                        <span
                          className="dropdown-item"
                          onClick={this.regenerateCFSMAGXml.bind(
                            this,
                            row.clientId,
                            row.userType
                          )}
                        >
                          Regenerate CFS-MAG XML
                        </span>
                        <XmlDownload
                          type="cfs-mag"
                          displayTitle="CFS-MAG"
                          obj={{
                            clientId: row.clientId,
                            userType: row.userType,
                          }}
                        />
                      </React.Fragment>
                    ) : null}
                  </div>
                </div>
              ) : null}
            </div>
          );
        },
      },
    ],
    loading: false,
    message: "",
    validationErrors: {},
    dropdownHidden: true,
    allClientsDropdown: [],
    regenerateMsg: "",
  };

  handleInputChange(e) {
    const value = e.target.value;
    const name = e.target.name;
    let validationErrors = Object.assign({}, this.state.validationErrors);
    if (name === "clientName") {
      if (value && !validation.isValidcompanyName(value)) {
        validationErrors.clientNameError =
          "Name can only contain alphabets and space";
      } else {
        validationErrors.clientNameError = "";
        this.createDropdownList(value);
      }
    }
    if (name === "panNo") {
      if (value && !validation.isValidPAN(value)) {
        validationErrors.panNoError = "Please enter valid PAN";
      } else {
        validationErrors.panNoError = "";
      }
    }
    if (name === "gstin") {
      if (value && !validation.isValidGST(value)) {
        validationErrors.gstinError = "Please enter valid GSTIN";
      } else {
        validationErrors.gstinError = "";
      }
    }

    if (name === "mobileNo") {
      if (value && !validation.isValidMobile(value)) {
        validationErrors.mobileNoError = "Please enter valid MOBILE";
      } else {
        validationErrors.mobileNoError = "";
      }
    }

    if (name === "email") {
      if (value && !validation.isValidEmail(value)) {
        validationErrors.emailError = "Please enter valid MOBILE";
      } else {
        validationErrors.emailError = "";
      }
    }

    if (name === "clientName" || name === "panNo" || name === "gstin") {
      this.setState({
        client: {
          ...this.state.client,
          [name]: value.toUpperCase(),
        },
        validationErrors: validationErrors,
        message: "",
      });
    } else {
      this.setState({
        client: {
          ...this.state.client,
          [name]: value,
        },
        validationErrors: validationErrors,
        message: "",
      });
    }
  }

  updateClient(clientId, action) {
    var that = this;
    if (action === "deactivate" || action === "delete") {
      if (
        action === "deactivate" &&
        that.state.data[0].activeInactive === "In-active"
      ) {
        Utility.showAlert("This client is In-active");
        return false;
      }
      var config = {
        message: "Are you sure you want to " + action + "?",
        onYesClick: async function () {
          that.onUpdateClient(clientId, action);
        },
        onNoClick: null,
      };
      Utility.showConfirm(config);
    } else {
      that.onUpdateClient(clientId, action);
    }
  }

  async onUpdateClient(clientId, action) {
    Loader.showLoader();
    let { response, err } = await clientsearchservice.updateClient(
      clientId,
      action
    );
    Loader.hideLoader();
    if (err) {
      this.setState({
        message: err,
      });
    } else if (response && response.data.err) {
      this.setState({
        message: response.data.err,
      });
    } else {
      this.onSearch();
    }
  }

  validateFields() {
    let { clientName, panNo, gstin, mobileNo, email } = this.state.client;
    let checkValidation = true;
    let validationErrors = Object.assign({}, this.state.validationErrors);
    if (clientName && !validation.isValidcompanyName(clientName)) {
      validationErrors.clientNameError =
        "Name can only contain alphabets and space";
      checkValidation = false;
    }
    if (panNo && !validation.isValidPAN(panNo)) {
      validationErrors.panNoError = "Please enter valid PAN";
      checkValidation = false;
    }
    if (gstin && !validation.isValidGST(gstin)) {
      validationErrors.gstinError = "Please enter valid GSTIN";
      checkValidation = false;
    }

    if (mobileNo && !validation.isValidMobile(mobileNo)) {
      validationErrors.mobileNoError = "Please enter valid MOBILE";
      checkValidation = false;
    }

    if (email && !validation.isValidEmail(email)) {
      validationErrors.emailError = "Please enter valid EMAIL";
      checkValidation = false;
    }
    this.setState({
      validationErrors: validationErrors,
    });
    return checkValidation;
  }

  async onSearch() {
    Loader.showLoader();
    let allowSearch = this.validateFields();
    if (allowSearch) {
      let { response, err } = await clientsearchservice.searchClient(
        this.state.client
      );
      Loader.hideLoader();
      if (err) {
        this.setState({
          message: "Error: " + err,
        });
      } else if (response && response.data.err) {
        this.setState({
          message: "Error: " + response.data.err,
        });
      } else {
        this.setState({
          data: response.data.length > 0 && response.data,
        });
      }
    } else {
      Loader.hideLoader();
    }
  }

  async regenerateXml(clientId, userType) {
    let data = {
      clientId: clientId,
      userType: userType,
    };
    Loader.showLoader();
    let { response, err } = await xmlService.regenerateXml(data);
    Loader.hideLoader();
    if (err) {
    } else if (response.data && response.data.err) {
    } else {
      this.setState(
        {
          regenerateMsg: response.data.msg,
        },
        () => {
          setTimeout(() => this.setState({ regenerateMsg: "" }), 1000);
        }
      );
    }
  }
  async regenerateCFSMAGXml(clientId, userType) {
    let data = {
      clientId: clientId,
      userType: userType,
    };
    Loader.showLoader();
    let { response, err } = await xmlService.regenerateCFSMAGXml(data);
    Loader.hideLoader();
    if (err) {
    } else if (response.data && response.data.err) {
    } else {
      this.setState(
        {
          regenerateMsg: response.data.msg,
        },
        () => {
          setTimeout(() => this.setState({ regenerateMsg: "" }), 1000);
        }
      );
    }
  }

  async createDropdownList(value) {
    if (value === "") {
      this.setState({
        dropdownHidden: true,
      });
    } else {
      document.getElementById("loader").classList.remove("hide");
      let { response, err } = await clientsearchservice.getClientNames(value);
      document.getElementById("loader").classList.add("hide");
      if (err) {
        this.setState({
          message: "Error: " + err,
        });
      } else if (response && response.data.err) {
        this.setState({
          message: "Error: " + response.data.err,
        });
      } else {
        let allClients = [];
        if (response.data.length > 0) {
          for (let i = 0; i < response.data.length; i++) {
            allClients.push(
              <li
                onClick={this.assignClientValue.bind(
                  this,
                  response.data[i].customer
                )}
                value={response.data[i].customer}
                key={response.data[i].clientId}
                id={response.data[i].customer}
                style={{ cursor: "pointer", marginLeft: "7px" }}
              >
                {response.data[i].customer}
              </li>
            );
          }
        }
        this.setState({
          dropdownHidden: false,
          allClientsDropdown: allClients,
        });
      }
    }
  }

  assignClientValue(value) {
    this.setState({
      client: {
        ...this.state.client,
        clientName: value,
      },
      dropdownHidden: true,
    });
  }

  assignClientKeyPress(e) {
    var nodes = document.getElementById("search_list").childNodes;
    if (nodes.length > 0) {
      if (e.keyCode === 40) {
        if (this.clientCount < nodes.length - 1) {
          this.clientCount++;
        }

        for (let i = 0; i < nodes.length; i++) {
          if (this.clientCount === i) {
            nodes[i].style.background = "lightblue";
          } else {
            nodes[i].style.background = "";
          }
        }
      } else if (e.keyCode === 38) {
        if (this.clientCount > 0) {
          this.clientCount--;
        }

        for (let i = 0; i < nodes.length; i++) {
          if (this.clientCount === i) {
            nodes[i].style.background = "lightblue";
          } else {
            nodes[i].style.background = "";
          }
        }
      } else if (e.keyCode === 13) {
        e.preventDefault();
        this.assignClientValue(nodes[this.clientCount].id);
      }
    }
  }

  render() {
    const authorizationResult = super.render();
    if (authorizationResult) {
      return authorizationResult;
    }

    let {
      clientName,
      panNo,
      gstin,
      clientCode,
      mobileNo,
      email,
    } = this.state.client;
    let {
      clientNameError,
      panNoError,
      gstinError,
      mobileNoError,
      emailError,
    } = this.state.validationErrors;
    var d = new Date();
    var dateTime =
      d.getFullYear() +
      "-" +
      d.getMonth() +
      "-" +
      d.getDate() +
      "_" +
      d.getHours() +
      "-" +
      d.getMinutes() +
      "-" +
      d.getSeconds();

    const datatable = (
      <DataTable
        className="data-table"
        keyField="id"
        pagination={{
          enabled: false,
          pageLength: 20,
          type: "long",
        }}
        width="100%"
        headers={this.state.headers}
        data={this.state.data.length > 0 ? this.state.data : []}
        excelHeaders={this.state.excelHeaders}
        filename={this.state.statusTab + "_" + dateTime + ".csv"}
        pdfTitle={this.state.statusTab}
        noData="No records!"
      />
    );

    return (
      <div className="container">
        <div className="row ">
          <div className="col-sm-12  mt-2 pt-2">
            <div className="col-sm-12 card pt-3 rounded-0">
              <h4 className="text-uppercase text-center mt-0 mb-0 text-primary">
                {" "}
                Search A Client{" "}
              </h4>
              <div className="text-center text-muted">
                <small> Fill any one or multiple fields</small>
              </div>
              <hr className="mt-1" />
              <div className="row">
                <div className="col-sm-3">
                  <div className="form-group fg-animate">
                    <span id="loader" className="loading hide"></span>
                    <label htmlFor="Name">Name</label>
                    <input
                      required
                      type="text"
                      value={clientName}
                      className="form-control"
                      onChange={this.handleInputChange}
                      onKeyDown={this.assignClientKeyPress.bind(this)}
                      name="clientName"
                      autoComplete="off"
                      style={{ position: "relative" }}
                    />
                    <div
                      className="search-redult-div"
                      hidden={this.state.dropdownHidden}
                    >
                      <ul type="none" className="pl-0" id="search_list">
                        {this.state.allClientsDropdown}
                      </ul>
                    </div>
                  </div>
                  <span className="error-msg">{clientNameError}</span>
                </div>
                <div className="col-sm-3">
                  <div className="form-group fg-animate">
                    <label htmlFor="PAN">PAN</label>
                    <input
                      required
                      type="text"
                      className="form-control"
                      name="panNo"
                      onChange={this.handleInputChange}
                      value={panNo}
                      maxLength="10"
                    />
                    <span className="error-msg">{panNoError}</span>
                  </div>
                </div>

                <div className="col-sm-3">
                  <div className="form-group fg-animate">
                    <label htmlFor="GSTIN">GSTIN</label>
                    <input
                      required
                      type="text"
                      className="form-control"
                      name="gstin"
                      onChange={this.handleInputChange}
                      value={gstin}
                      maxLength="15"
                      autoComplete="off"
                    />
                    <span className="error-msg">{gstinError}</span>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="form-group fg-animate">
                    <label htmlFor="Fin Ledger Code">Fin Ledger Code</label>

                    <input
                      required
                      type="text"
                      className="form-control"
                      name="clientCode"
                      onChange={this.handleInputChange}
                      value={clientCode}
                      maxLength="10"
                      autoComplete="off"
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-3">
                  <div className="form-group fg-animate">
                    <label htmlFor="MOBILE">Mobile</label>
                    <input
                      required
                      type="text"
                      className="form-control"
                      name="mobileNo"
                      onChange={this.handleInputChange}
                      value={mobileNo}
                      maxLength="10"
                      autoComplete="off"
                    />
                    <span className="error-msg">{mobileNoError}</span>
                  </div>
                </div>

                <div className="col-sm-3">
                  <div className="form-group fg-animate">
                    <label htmlFor="MOBILE">Email</label>
                    <input
                      required
                      type="text"
                      className="form-control"
                      name="email"
                      onChange={this.handleInputChange}
                      value={email}
                      maxLength="150"
                      autoComplete="off"
                    />
                    <span className="error-msg">{emailError}</span>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group ">
                    <button
                      className="btn btn-info btn-md rounded-0 col-sm-2 offset-sm-10 search "
                      disabled={
                        !(
                          clientName ||
                          panNo ||
                          gstin ||
                          clientCode ||
                          mobileNo ||
                          email
                        )
                      }
                      onClick={this.onSearch}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <span style={{ color: "red" }}>{this.state.message}</span>
        </div>

        <div className="row mt-2">
          {this.state.regenerateMsg ? (
            <span style={{ color: "green" }}>{this.state.regenerateMsg}</span>
          ) : null}
          <div className="col-sm-12">{datatable}</div>
        </div>
      </div>
    );
  }
}
